<cm-routed-dialog #overlayDialog [dialogSize]="DialogSize.Large" [dialogScroll]="false" [needsConfirmationToClose]="$isEdited()">
    <ng-container cm-overlay-content>
        @if (($showSpinner() || !$isInitialFrameDrawn()) && !$initialLoadError()) {
            <div class="cm-image-state-overlay">
                <mat-progress-spinner mode="indeterminate" [diameter]="48" [strokeWidth]="6" color="primary"></mat-progress-spinner>
            </div>
        }
        <div class="cm-main-card">
            <div class="cm-section-label">
                <button class="cm-back-icon" (click)="navigateBack()" matTooltip="Back to material">
                    <i class="far fa-chevron-left"></i>
                </button>
                @if ($data(); as data) {
                    <div class="cm-revision-tabs">
                        @for (revision of data.textureSetRevisionSpecific.sortedTextureSetRevisionDescriptors | slice: 0 : 5; track revision.id) {
                            <div
                                (click)="data.textureSetRevisionSpecific.textureSetRevision.id !== revision.id ? setTextureSetRevision(revision.id) : null"
                                class="cm-revision-tab"
                                [class.cm-revision-tab-active]="data.textureSetRevisionSpecific.textureSetRevision.id === revision.id"
                            >
                                <div class="cm-revision-title">
                                    {{ $getRevisionTitle()(revision, data.textureSetRevisionSpecific.sortedTextureSetRevisionDescriptors.length - $index) }}
                                </div>
                                @if (data.textureSetRevisionSpecific.textureSetRevision.id === revision.id) {
                                    <div class="cm-revision-actions">
                                        <i class="far fa-ellipsis-v cm-revision-menu" [matMenuTriggerFor]="moreMenu"></i>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    @if (data.textureSetRevisionSpecific.sortedTextureSetRevisionDescriptors.length >= 5) {
                        <i class="far fa-chevron-down cm-revision-tabs-dropdown" [matMenuTriggerFor]="revisionMenu"></i>
                        <mat-menu #revisionMenu="matMenu" yPosition="below">
                            @for (revision of data.textureSetRevisionSpecific.sortedTextureSetRevisionDescriptors | slice: 5; track revision.id) {
                                <button
                                    class="cm-revision-menu-item"
                                    [class.cm-revision-menu-item-active]="data.textureSetRevisionSpecific.textureSetRevision.id === revision.id"
                                    mat-menu-item
                                    (click)="setTextureSetRevision(revision.id)"
                                >
                                    {{ $getRevisionTitle()(revision, data.textureSetRevisionSpecific.sortedTextureSetRevisionDescriptors.length - $index - 5) }}
                                </button>
                            }
                        </mat-menu>
                    }
                }

                <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item (click)="renameRevision()">Rename</button>
                    <button mat-menu-item (click)="adjustSize()">Adjust size</button>
                    <mat-divider></mat-divider>
                    @if ($hasOperators()) {
                        <button mat-menu-item [disabled]="$isEdited()" (click)="copyCurrentRevision(true)">Copy revision with operators</button>
                        <button mat-menu-item [disabled]="$isEdited()" (click)="copyCurrentRevision(false)">Copy revision without operators</button>
                    } @else {
                        <button mat-menu-item [disabled]="$isEdited() || $isProcessingEdits()" (click)="copyCurrentRevision(false)">Copy revision</button>
                    }
                    <mat-divider></mat-divider>
                    <button mat-menu-item [disabled]="$isInUse()" (click)="deleteCurrentRevision()">Delete revision</button>
                    <!--                    @if (enableDebugFeatures) {-->
                    <!--                        <mat-divider></mat-divider>-->
                    <!--                        <button mat-menu-item (click)="downloadGraph()">Download image op graph</button>-->
                    <!--                    }-->
                </mat-menu>
            </div>
            <div class="cm-left-panel-container">
                @if ($processingJobId(); as jobId) {
                    <cm-job-task-progress [jobId]="jobId"></cm-job-task-progress>
                }

                @if ($initialLoadError(); as loadError) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text>This texture revision could not be loaded: {{ loadError.message }}</ng-container>
                    </cm-hint>
                } @else if (!$hasValidResolutions()) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text> The maps in this revision do not permit editing because they are of inconsistent resolution.</ng-container>
                    </cm-hint>
                } @else if (!$hasValidRatio()) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text>
                            The maps in this revision do not permit editing because they contain non-square pixel ratios.<br /><br /><b
                                ><a href="javascript:void(0)" (click)="adjustSize()">Click here to adjust the physical size accordingly. </a></b
                            >
                        </ng-container>
                    </cm-hint>
                }
                @if ($isInUse()) {
                    <cm-hint>
                        <ng-container cm-text> This revision is used by a material and can not be modified or removed.</ng-container>
                    </cm-hint>
                } @else if (!$canEditDisplacementMap()) {
                    <cm-hint>
                        <ng-container cm-text>
                            The displacement map can not be edited because it is auto-generated from the normal map. Only the final result will be displayed.
                        </ng-container>
                    </cm-hint>
                }

                <div class="cm-texture-revision-group">
                    <cm-texture-selector
                        #textureSelector
                        [textureSetRevision]="data?.textureSetRevisionSpecific?.textureSetRevision"
                        [availableTextureTypes]="data?.textureSetRevisionSpecific?.availableTextureTypes ?? []"
                        [selectedTextureType]="data?.textureTypeSpecific?.textureType ?? TextureType.Diffuse"
                        (selectedTextureTypeChange)="setTextureType($event)"
                    >
                    </cm-texture-selector>
                    <cm-tiling-info-panel
                        [createdByName]="data?.textureSetRevisionSpecific?.textureSetRevision?.createdBy?.name"
                        [createdAt]="data?.textureSetRevisionSpecific?.textureSetRevision?.createdAt"
                        [updatedByName]="data?.textureSetRevisionSpecific?.textureSetRevision?.updatedBy?.name"
                        [updatedAt]="data?.textureSetRevisionSpecific?.textureSetRevision?.updatedAt ?? undefined"
                        [imageColorSpace]="data?.textureTypeSpecific?.resultDataObject?.imageColorSpace ?? undefined"
                        [pxPerCm]="data?.textureTypeSpecific?.pxPerCm"
                        [resultResolution]="$resultResolution()"
                        [resultFileSize]="data?.textureTypeSpecific?.resultDataObject?.size"
                        [displacement]="data?.textureSetRevisionSpecific?.textureSetRevision?.displacement ?? undefined"
                    ></cm-tiling-info-panel>
                </div>
                @if ($hasOperatorStack()) {
                    <cm-operators-panel [disabled]="!$canEdit()" [operatorStack]="$operatorStack()" (importOperators)="importOperatorsFromRevision()">
                        <ng-container cm-extra-content>
                            @if ($isEdited()) {
                                @if (!$isOperatorStackValid()) {
                                    <cm-hint [hintType]="HintTypes.Warning">
                                        <ng-container cm-text>
                                            @for (msg of $operatorValidationMessages(); track msg) {
                                                {{ msg }}
                                            }
                                        </ng-container>
                                    </cm-hint>
                                }
                                <div class="cm-submission-buttons">
                                    <cm-button
                                        (click)="save()"
                                        class="cm-save"
                                        [class.cm-active]="$isOperatorStackValid()"
                                        [disabled]="!$isOperatorStackValid()"
                                    >
                                        <ng-container cm-left-icon>
                                            <i class="far fa-play"></i>
                                        </ng-container>
                                        <ng-container cm-text> Submit changes</ng-container>
                                    </cm-button>
                                    <cm-button (click)="discardChanges()">
                                        <ng-container cm-left-icon>
                                            <i class="far fa-trash"></i>
                                        </ng-container>
                                        <ng-container cm-text> Discard changes</ng-container>
                                    </cm-button>
                                </div>
                            }
                        </ng-container>
                    </cm-operators-panel>
                }
            </div>
            <div class="cm-inspector-area">
                @let selectedOperator = $selectedOperator();
                <cm-operator-inspector
                    [disabled]="!$canEdit()"
                    [textureEditCanvas]="$tilingCanvas()"
                    [availableTextureTypes]="$availableTextureTypesForOperators()"
                    [operator]="selectedOperator && !selectedOperator.$locked() ? selectedOperator : null"
                >
                </cm-operator-inspector>
            </div>
            <div class="cm-viewer-section">
                <cm-tiling-canvas
                    #tilingCanvasRef
                    [callback]="this"
                    [gridActive]="$gridActive()"
                    [gridOutlineActive]="$gridOutlineActive()"
                    [physicalInfo]="$physicalInfo()"
                    [suspendRedraws]="$showSpinner()"
                    [onAboutToBeDestroyed]="disposeOperatorStack"
                    (frameDrawn)="onFrameDrawn()"
                    (loadError)="onCanvasLoadError($event)"
                >
                </cm-tiling-canvas>
                <cm-tiling-controls
                    #tilingControls
                    [dataObject]="data?.textureTypeSpecific?.resultDataObject"
                    [canDownload]="data !== undefined && !$isProcessingEdits() && !$isEdited()"
                    (zoomClick)="zoomToPhysicalPixels()"
                    [gridActive]="$gridActive()"
                    (gridClick)="toggleGrid()"
                    [brightnessBoostActive]="$brightnessBoostActive()"
                    (brightnessBoostToggle)="toggleBrightnessBoost()"
                ></cm-tiling-controls>
            </div>
        </div>
    </ng-container>
</cm-routed-dialog>
